import { ELocale, DomainTranslations } from 'App/i18n/i18n.types';

import Domain from 'commons/utils/domains';

import esAR from './reverse-shipment.es-AR.json';
import esMX from './reverse-shipment.es-MX.json';
import ptBR from './reverse-shipment.pt-BR.json';

const reverseShipmentTranslations: DomainTranslations = {
  name: Domain.REVERSE_SHIPMENT,
  languages: {
    [ELocale.ARGENTINA]: esAR,
    [ELocale.MEXICO]: esMX,
    [ELocale.BRAZIL]: ptBR
  }
};

export default reverseShipmentTranslations;
